export default "__VITE_PUBLIC_ASSET__ae365b0b__"